import { render, staticRenderFns } from "./InboundLog.vue?vue&type=template&id=15fddab6"
import script from "./InboundLog.vue?vue&type=script&lang=js"
export * from "./InboundLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports